import { useMemo } from "react";
import { DataTable } from "./DataTable";

const ShipmentAnalysisTable = ({ orders, isLoading, isError }) => {
  const tableColumns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "invoice",
        disableSortBy: true,
      },
      {
        Header: "Route",
        accessor: "route",
        disableSortBy: true,
      },
      {
        Header: "Customer",
        accessor: "customer",
        Cell: (rowData) => {
          if (rowData.value !== "Sub Total") {
            return <span>{rowData.value}</span>;
          } else {
            return <b>{rowData.value}</b>;
          }
        },
        disableSortBy: true,
      },
      {
        Header: "City",
        accessor: "city",
        disableSortBy: true,
      },
      {
        Header: "Stops",
        accessor: "stops",
        disableSortBy: true,
      },
      {
        Header: "Pieces",
        accessor: "pieces",
        disableFilters: true,
        width: 80,
        maxWidth: 80,
      },
      {
        Header: "Pallet",
        accessor: "pallet",
        disableFilters: true,
        width: 80,
        maxWidth: 80,
      },
      {
        Header: "Engine",
        accessor: "engine",
        disableFilters: true,
        width: 80,
        maxWidth: 80,
      },
      {
        Header: "Transmission",
        accessor: "TeansM",
        disableFilters: true,
        width: 120,
        maxWidth: 120,
      },
      {
        Header: "CODs",
        accessor: "cods",
        disableFilters: true,
        width: 80,
        maxWidth: 80,
      },
      {
        Header: "Sales",
        accessor: "sales",
        disableFilters: true,
        width: 80,
        maxWidth: 80,
      },
    ],
    []
  );

  const tableData = useMemo(
    () =>
      orders.map((val) => {
        return {
          invoice: val.invoice,
          deliveryDate: new Date(val.deliveryDate),
          creationDate: new Date(val.creationDate),
          customer: val.customer,
          TeansM: val.transm,
          city: val.city,
          stops: val.stops,
          customerZip: val.customerZip,
          customerPhoneNumber: val.customerPhoneNumber,
          route: val.route,
          pieces: val.pieces,
          cods: val.isCod ? "Yes" : "No",
          engine: val.engine,
          sales: val.amount,
          deliveryType: val.deliveryType,
          pallet: val.pallet,
          deliveryMenu: {
            deliveryId: val.deliveryId,
            deliveryStatus: val.status,
            buyoutOrReturn:
              val.deliveryType === "Buy Out" || val.deliveryType === "Return",
          },
        };
      }),
    [orders]
  );

  return (
    <DataTable
      columns={tableColumns}
      data={tableData}
      isLoading={isLoading}
      isError={isError}
      slotProps={{
        topToolbar: {
          disabled: true,
        },
      }}
    />
  );
};

export default ShipmentAnalysisTable;
